import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DoctorService from "../services/DoctorService";

export default function DoctorList() {
  const [doctors, setDoctors] = useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const loadDoctors = async () => {
      try {
        const data = await DoctorService.getAll();
        setDoctors(data);
      } catch (err) {
        console.error("Error fetching doctors:", err);
        setError(`Neuspešno učitavanje doktora: ${err.message}`);
      }
    };
    loadDoctors();
  }, []);

  const editDoctor = (id) => navigate(`/doctors/${id}/edit`);
  const deleteDoctor = async (id) => {
    try {
      await DoctorService.delete(id);
      setDoctors(doctors.filter((d) => d.doctorID !== id));
    } catch (err) {
      console.error("Error deleting doctor:", err);
      setError(`Neuspešno brisanje doktora: ${err.message}`);
    }
  };

  return (
    <div className="container mt-4">
      <h2>Doktori</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {doctors.length === 0 && !error ? (
        <p>Nema dostupnih doktora.</p>
      ) : (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {doctors.map((d) => (
              <tr key={d.doctorID}>
                <td>{d.doctorID}</td>
                <td>{d.firstName}</td>
                <td>{d.lastName}</td>
                <td>{d.email}</td>
                <td>
                  <button
                    className="btn btn-sm btn-warning me-2"
                    onClick={() => editDoctor(d.doctorID)}
                  >
                    Edit
                  </button>
                  
                  
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <button className="btn btn-primary mb-3" onClick={() => navigate("/doctors/new")}>
        Add Doctor
      </button>
    </div>
  );
}